import { crudRequest, selectByCodes } from '@/services/api';

import { OutletsNextSiteQuery } from '../Tables/OutletsDepartureTable/Sql';
import Queryable from '@/Entity/Tools/Queryable';
import { computeWeightNotAbs } from '@/utils/query';
import { considerZero } from '@/utils/utils';
import { getData_Vehicle } from '@/components/report/service';
import moment from 'moment';

// 3465 网点预计到达货量变更历史数据剔除
// eslint-disable-next-line no-unused-vars
function filterChangeCenterSite(data = [], centerFilterCode = '') {
  const properties = [
    'originCalcWeight',
    'trainsCalcWeight',
    'unloadedCalcWeight',
    'superiorityWeight',
    'setTotal',
    'dailyCalcWeight',
  ];
  return data.filter(item => {
    // item.centerCode === centerFilterCode &&
    return properties.some(prop => item[prop]);
  });
}



export default {
  namespace: 'centerWeightViewOutletsTables',
  state: {
    tableItem2: [],
    dataListCache: null,
    showDesSite: false,
    showPreSiteFlag: true,
    page: 1,
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      yield put({ type: 'getPlanDeparture' });
    },
    // 网点预计出发货量
    *getPlanDeparture(_, { call, put, select }) {
      let query = yield select(({ centerWeightViewSite, centerWeightViewOutletsTables }) => {
        return {
          sitePlan: centerWeightViewSite.sitePlan,
          actualDepartureCarsItem: centerWeightViewSite.actualDepartureCarsItem,
          volumeItem: centerWeightViewSite.volumeItem,
          centerFilter: centerWeightViewSite.centerFilter,
          centerFilterCode: centerWeightViewSite.centerFilterCode,
          siteName: centerWeightViewSite.centerFilter.replace('分拨中心', ''),
          startDate: moment(centerWeightViewSite.dateRange[0]).format(
            centerWeightViewSite.defualtDateFormat,
          ),
          endDate: moment(centerWeightViewSite.dateRange[1]).format(
            centerWeightViewSite.defualtDateFormat,
          ),
          showDesSite: centerWeightViewOutletsTables.showDesSite,
          // showPreSiteFlag: centerWeightViewOutletsTables.showPreSiteFlag,
        };
      });
      console.log(`上站已发：${JSON.stringify(query.sitePlan)}`);
      const filter = OutletsNextSiteQuery({
        scanSiteCode: query.centerFilterCode,
        startDate: query.startDate,
        endDate: query.endDate,
        centerFilter: query.centerFilter,
      });
      const result = yield call(getData_Vehicle, filter[0]);
      try {
        if (result?.length > 0) {
          let levelOneSite, centerSite;
          
          try {
            // 尝试获取站点信息
            ({ levelOneSite, centerSite } = yield* fetchSite());
          } catch (error) {
            console.error('Error fetching site data:', error);
            throw new Error('Failed to fetch site data');
          }
      
          const siteName = query.centerFilter.replace('分拨中心', '');
          // 网点数据
          const results = [];
          
          for (let i = 0; i < filter[1].length; i++) {
            try {
              const d = yield call(getData_Vehicle, filter[1][i]);
              const temp = new Map();
              d.map(item => {
                temp.set(item.destinationSiteCode, item);
              });
              results.push(temp);
            } catch (error) {
              console.error(`Error fetching vehicle data for filter ${i}:`, error);
              results.push(new Map());  // 如果失败，仍然推进一个空 Map
            }
          }
      
          console.log('%c [ results ]-85', 'font-size:13px; background:pink; color:#bf2c9f;', results);
      
          result.forEach((item, index) => {
            const firstSite = levelOneSite?.[item.destinationSiteCode]?.firstSite ?? {};
            const { siteName: siteNames = '', isReceive = null, stockBindSite = {} } = firstSite;
            
            // 检查 centerSite 是否为空
            const center = centerSite?.[item.destinationSiteCode] ?? {};
            const { sendCenterCode = '', sendCenterName = '' } = center;
          
            // 更新 item 中的站点信息
            item.levelOnSiteName =
              isReceive === 20 && stockBindSite?.siteName ? stockBindSite.siteName : siteNames;
          
            results.forEach((items, index2) => {
              const calcWeightTotals = items.get(item.destinationSiteCode);
              if (calcWeightTotals) {
                item[`calcWeight${index2}`] = calcWeightTotals.calcWeight || 0;
              }
            });
          
            //#region 拼接数据
            item.index = index;
            item.site = siteName;
            item.siteName = query.centerFilter;
            item.centerCode = sendCenterCode;
            item.centerName = sendCenterName;
      
            const calcWeight0 = item.calcWeight0 || 0;
            const calcWeight1 = item.calcWeight1 || 0;
            if (Math.abs(calcWeight0) < Math.abs(calcWeight1)) {
              item.originCalcWeight = 0;
            } else {
              item.originCalcWeight = computeWeightNotAbs(calcWeight0 - calcWeight1);
            }
      
            const calcWeight2 = item.calcWeight2 || 0;
            const calcWeight3 = item.calcWeight3 || 0;
            if (Math.abs(calcWeight2) < Math.abs(calcWeight3)) {
              item.trainsCalcWeight = 0;
            } else {
              item.trainsCalcWeight = computeWeightNotAbs(calcWeight2 - calcWeight3);
            }
      
            const calc = (item.calcWeight4 || 0) + (item.calcWeight5 || 0);
            item.unloadedCalcWeight = calc > 0 ? computeWeightNotAbs(calc) : 0;
      
            const calcPy = (item.calcWeight6 || 0) + (item.calcWeight7 || 0);
            item.superiorityWeight = calcPy > 0 ? computeWeightNotAbs(calcPy) : 0;
      
            const calcWeight8 = item.calcWeight8 || 0;
            if (calcWeight8) {
              item.dailyCalcWeight = Number(
                (computeWeightNotAbs(calcWeight8) / 7).toFixed(
                  computeWeightNotAbs(calcWeight8 || 0) / 7 > 0.1 ? 1 : 2,
                ),
              );
            } else {
              item.dailyCalcWeight = 0;
            }
      
            item.setTotal = Number.parseFloat(
              (item.originCalcWeight || 0) +
              (item.trainsCalcWeight || 0) +
              (item.unloadedCalcWeight || 0),
            ).toFixed(1);
          });
        }
      } catch (error) {
        console.error('Error processing data:', error);
        // 你可以根据需求在这里做进一步的错误处理，比如显示用户友好的错误消息
      }
      
      const filterResult = filterChangeCenterSite(result, query.centerFilterCode);
      //#region 根据一级网点分组,相同网点的放在一起
      // const dataList = Object.values(groupBys(result, 'levelOnSiteName')).reduce((f, b) => f.concat(b))

      const dataListCache = new Queryable(filterResult).GroupByField('levelOnSiteName');
      const dataList = dataListCache.AggreObject([
        'originCalcWeight',
        'trainsCalcWeight',
        'unloadedCalcWeight',
        'superiorityWeight',
        'setTotal',
        'dailyCalcWeight',
      ]);

      //#endregion
      let dataSource = [];
      try {
        dataSource = query.showDesSite
          ? Object.values(dataListCache).reduce((f, b) => f.concat(b), [])
          : dataList;
        // dataSource = dataSource.filter(item => query.centerFilterCode === item.centerCode);
        dataSource = dataSource.filter(
          item =>
            !considerZero(item.originCalcWeight, 0)
            || !considerZero(item.trainsCalcWeight, 0)
            || !considerZero(item.unloadedCalcWeight, 0)
            || query.centerFilterCode === item.centerCode

        );
      } catch (error) {
        dataSource = [];
      }
      yield put({
        type: 'update',
        payload: {
          dataListCache,
          tableItem2: dataSource,
        },
      });
      /** 获取一级网点 以及 分拨 */
      function* fetchSite() {
        const siteCodes = result.map(item => item.destinationSiteCode);
        let levelOneSite = {}; // 一级网点
        let centerSite = {}; // 分拨
        const fetchLevelOneSiteCount = 100;
        const promiseAll = [];
        const sitePromiseAll = [];
        for (let i = 0; i < siteCodes.length; i += fetchLevelOneSiteCount) {
          const fetch = crudRequest(
            `/api/station/business/batchSelectDeliverySite`,
            {
              paramType: 'siteCode',
              queryParam: siteCodes.slice(i, i + fetchLevelOneSiteCount),
            },
            { module: 'mdp-station-business' },
          );
          const fetchSites = selectByCodes(siteCodes.slice(i, i + fetchLevelOneSiteCount));
          promiseAll.push(fetch);
          sitePromiseAll.push(fetchSites);

        }
        const levelOneSiteResult = yield Promise.all(promiseAll);
        const sitesResult = yield Promise.all(sitePromiseAll);
        levelOneSiteResult.map(data => {
          if (data.code === 1) {
            levelOneSite = { ...levelOneSite, ...data.data };
          }
        });
        sitesResult.map(data => {
          if (data.code === 1) {
            centerSite = { ...centerSite, ...data.data };
          }
        });
        return {
          levelOneSite,
          centerSite,
        };
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
